import type { IManualPlatformLinkData } from './manualPlatformLinkUtils';

/** True in local dev / development builds — used for QA autofill shortcuts. */
export function isDevAutofillEnabled(): boolean {
    const env = (process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || '').toLowerCase();
    return env === 'dev' || env === 'development';
}

const DEV_HEADSHOT_PREVIEW =
    'data:image/svg+xml;base64,' +
    btoa(
        '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"><rect fill="#ffc965" width="80" height="80" rx="40"/><text x="40" y="46" text-anchor="middle" fill="#1a1919" font-size="13" font-family="sans-serif" font-weight="700">DEV</text></svg>',
    );

/** Minimal JPEG bytes so upload sagas accept a File in dev. */
export function createDevHeadshotFile(): File {
    return new File([new Uint8Array([0xff, 0xd8, 0xff, 0xd9])], 'dev-headshot.jpg', { type: 'image/jpeg' });
}

export function getDevManualPlatformLinkData(): IManualPlatformLinkData {
    const suffix = String(Date.now()).slice(-6);
    return {
        userName: `devcreator${suffix}`,
        followers: '12500',
        lastPostViews: '8400',
        lastPostComments: '142',
        lastPostLikes: '980',
        headshotPreview: DEV_HEADSHOT_PREVIEW,
        headshotFile: createDevHeadshotFile(),
    };
}

export interface IDevGuestSignupFields {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    phone: string;
}

/** US E.164 digits without + — valid for react-phone-input-2 and our validators. */
export function getDevPhoneNumber(suffix = String(Date.now()).slice(-6)): string {
    const subscriber = suffix.slice(-4).padStart(4, '0');
    return `1415555${subscriber}`;
}

export function getDevGuestSignupFields(): IDevGuestSignupFields {
    const suffix = String(Date.now()).slice(-6);
    return {
        firstName: 'Dev',
        lastName: 'Creator',
        email: `dev.creator.${suffix}@mailinator.com`,
        password: 'DevPass1',
        phone: getDevPhoneNumber(suffix),
    };
}

export interface IDevEsSignupFields {
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    phoneNumber: string;
}

/** Fields for the main EsSignupForm step (full name + phone + email + password). */
export function getDevEsSignupFields(): IDevEsSignupFields {
    const signup = getDevGuestSignupFields();
    return {
        fullName: `${signup.firstName} ${signup.lastName}`,
        firstName: signup.firstName,
        lastName: signup.lastName,
        email: signup.email,
        password: signup.password,
        phoneNumber: signup.phone,
    };
}

export interface IDevBrandManualSocialLinkData {
    url: string;
    username: string;
    follower_count: string;
    engagement_rate: string;
}

/** Sample brand social profile for manual link QA (brand onboarding step 2). */
export function getDevBrandManualSocialLinkData(
    platform: 'instagram' | 'tiktok' | 'youtube',
): IDevBrandManualSocialLinkData {
    const suffix = String(Date.now()).slice(-4);
    const handle = `thspian${suffix}`;
    const urls: Record<typeof platform, string> = {
        instagram: `https://www.instagram.com/${handle}`,
        tiktok: `https://www.tiktok.com/@${handle}`,
        youtube: `https://www.youtube.com/@${handle}`,
    };
    return {
        url: urls[platform],
        username: handle,
        follower_count: '48200',
        engagement_rate: '3.8',
    };
}
